import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../FormGroup';
import Button from '../../../Button';

const propTypes = {
  onSave: PropTypes.func.isRequired,
};

const CardDesignerNameModal = ({ onSave }) => {
  const [name, setName] = useState('');

  const onFormSubmit = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!name.trim()) {
      return;
    }

    onSave(name.trim());
  };

  return (
    <form method="post" onSubmit={onFormSubmit}>
      <h3 className="text-center mb-3">Save this print template as&hellip;</h3>

      <FormGroup
        className="mb-2"
        id="card-designer-template-name"
        name="name"
        label="Template name"
        labelType="expanded"
        placeholder="Name your template here"
        labelSrOnly
        value={name}
        onChange={({ target }) => setName(target.value)}
        autoFocus
      />

      <div className="d-flex justify-content-center mt-2">
        <Button type="submit" disabled={!name.trim()}>
          Save
        </Button>
      </div>
    </form>
  );
};

CardDesignerNameModal.propTypes = propTypes;

export default CardDesignerNameModal;
